import { lazy } from "react";
import type { RouteConfig } from "../config";
import { ROUTES } from "../paths";

// Lazy-loaded components
const LoginPage = lazy(() =>
  import("@/pages/auth").then((m) => ({ default: m.LoginPage }))
);
const ForgotPasswordPage = lazy(() =>
  import("@/pages/auth").then((m) => ({ default: m.ForgotPasswordPage }))
);
const ResetPasswordPage = lazy(() =>
  import("@/pages/auth").then((m) => ({ default: m.ResetPasswordPage }))
);

/**
 * Authentication Routes
 *
 * Public routes for authentication flow (login, forgot password, reset password).
 * No authentication required for these routes.
 */
export const authRoutes: RouteConfig[] = [
  {
    path: ROUTES.LOGIN,
    component: LoginPage,
    layout: undefined,
    permissions: {
      access: "public",
    },
  },
  {
    path: ROUTES.FORGOT_PASSWORD,
    component: ForgotPasswordPage,
    layout: undefined,
    permissions: {
      access: "public",
    },
  },
  {
    path: ROUTES.RESET_PASSWORD,
    component: ResetPasswordPage,
    layout: undefined,
    permissions: {
      access: "public",
    },
  },
];
